import { render, staticRenderFns } from "./modalAdicionarItens.vue?vue&type=template&id=1c0ad98a&scoped=true&"
import script from "./modalAdicionarItens.vue?vue&type=script&lang=js&"
export * from "./modalAdicionarItens.vue?vue&type=script&lang=js&"
import style0 from "./modalAdicionarItens.vue?vue&type=style&index=0&id=1c0ad98a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ad98a",
  null
  
)

export default component.exports